import React from 'react';
import Avatar from 'react-avatar';
import PropTypes from 'prop-types';
import EditIcon from '@material-ui/icons/Edit';
import AddIcon from '@material-ui/icons/Add';
import { withTranslation } from 'react-i18next';
import { IconButton } from 'material-ui';
import { connect } from 'react-redux';
import {
  DEFAULT_FATHER_CODE,
  DEFAULT_LEVEL,
} from '../../../shared/utils/constants';

const SmartItem = (props) => {
  const {
    t,
    item,
    newItem,
    addItemHandler,
    editItemhandler,
    navigationHandler,
  } = props;

  return (
    <div className="card-item">
      {newItem ? (
        <>
          <div className="card-header-item">
            <h5 className="text-ellipsis bold-text pad-l12">
              {t('mnt_tablet-items.new')}
            </h5>
          </div>
          <div className="card-body-item">
            <IconButton
              className="card-item-icon-button"
              onClick={() =>
                addItemHandler({
                  id: DEFAULT_FATHER_CODE,
                  level: DEFAULT_LEVEL,
                  program: { id: 0 },
                })
              }
            >
              <AddIcon className="card-item-icon" />
            </IconButton>
          </div>
        </>
      ) : (
        <>
          <div className="card-header-item justify-content-between align-baseline">
            <h5 className="text-ellipsis bold-text pad-l12">
              {item.shortName}
            </h5>
            <IconButton
              className="card-icon-button"
              onClick={() => editItemhandler(item.id)}
            >
              <EditIcon />
            </IconButton>
          </div>
          <div
            className={
              item.active ? 'card-body-item' : 'card-body-item disabled-card'
            }
          >
            <Avatar
              size="50"
              round="50%"
              className={item.active ? 'cursor-pointer' : ''}
              src={item.iconTablet.link}
              name={item.name}
              onClick={item.active ? () => navigationHandler(item.id) : null}
            />
          </div>
        </>
      )}
    </div>
  );
};

SmartItem.propTypes = {
  t: PropTypes.func.isRequired,
  item: PropTypes.shape({
    id: PropTypes.number,
    active: PropTypes.bool,
    shortName: PropTypes.string,
    name: PropTypes.string,
    iconUrl: PropTypes.string,
    iconTablet: PropTypes.shape({
      id: PropTypes.number,
      link: PropTypes.string,
    }),
  }),
  newItem: PropTypes.bool,
  addItemHandler: PropTypes.func,
  editItemhandler: PropTypes.func,
  navigationHandler: PropTypes.func,
};

SmartItem.defaultProps = {
  item: null,
  newItem: null,
  addItemHandler: null,
  editItemhandler: null,
  navigationHandler: null,
};

export default withTranslation('common')(
  connect((state) => ({
    loading: state.loading,
  }))(SmartItem)
);
